<template>
  <div class="mb-4 box-container">
    <div class="ml-2">
      <div class="row">
        <SectionTitle
          class="responsive-section-title"
          icon="fas fa-file-medical"
          has-line
          content="Anejar Referido Firmado"
          bg-icon="green"
        />
      </div>
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <div class="row">
            <div class="col-12">
              <span class="custom-input-label">Tipo de Documento:</span>
            </div>
            <div class="col-12 mt-2">
              <span class="font-weight-normal">
                Referido para Solicitar Servicios de AT
              </span>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-5">
          <div :class="['row', { 'mt-4': isMobile }]">
            <ValidationObserver ref="uploadSignedReferral">
              <span class="custom-file-input-label">Archivo:</span>
              <ValidationProvider v-slot="{ errors }" rules="required">
                <CustomFileInput
                  ref="fileUpload"
                  v-model="value.signedReferral"
                  :on-download="() => {}"
                  :accept="'.pdf'"
                  display-style="normal"
                  label-position="left"
                  :error="errors[0]"
                  :custom-error-msg="resources['25034']"
                />
              </ValidationProvider>
            </ValidationObserver>
          </div>
        </div>

        <div class="col-md-3 col-sm-12 p-0 buttons-container">
          <ActionButton
            id="btnCancelDocument"
            variant="outline-danger mr-2"
            i="fas fa-times-circle"
            @click="
              () => {
                this.$emit('toggleAttachSignedReferral');
              }
            "
          >
            Cancelar
          </ActionButton>
          <ActionButton
            id="btnAddDocument"
            variant="success"
            i="fas fa-file-plus"
            @click="uploadSignedReferral"
          >
            Añadir
          </ActionButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';
import alert from 'utils/mixins/alert.mixin.js';
import resourcesService from '@/services/resources.js';
import { uploadSignedReferral } from '@/modules/request-tech-service-assistance/api';
import DocumentTypes from '@/utils/constants/documentTypes';
import store from '@/store/index';

export default {
  name: 'SignedReferralAttach',
  mixins: [alert],
  components: {
    SectionTitle,
    CustomFileInput,
    ActionButton,
  },
  data() {
    return {
      resources: [],
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {
        return { signedReferral: null };
      },
    },
  },
  computed: {
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
  },
  methods: {
    async uploadSignedReferral() {
      const isValid = await this.$refs.uploadSignedReferral.validate();

      if (!isValid) {
        return;
      }

      let formData = new FormData();
      formData.append('signedReferral', this.value.signedReferral);

      await uploadSignedReferral(this.value.peiATServiceId, formData)
        .then((res) => {
          if (res.status == 200) {
            this.ShowToast(
              'Proceso exitoso.',
              'Su referido fue formalmente procesado y se encuentra en la bandeja de trabajo del CAAT en estatus Pendiente de Análisis.',
              'success'
            );
            this.value.peiAtServiceStatusId = res.data.peiAtServiceStatusId;
            this.addDocument();
            this.$emit('toggleAttachSignedReferral');
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages(['25034']);
    },
    addDocument() {
      const file = {
        id: DocumentTypes.ReferralServiceAT,
        type: 'Referido para Solicitar Servicios de AT',
        fileName: this.value.signedReferral.name,
        file: this.value.signedReferral,
      };
      this.value.documents.push(file);
    },
  },
  async mounted() {
    await this.loadResources();
  },
};
</script>

<style scoped>
.box-container {
  background-color: #f7f7f7;
  padding: 15px;
  border-radius: 5px;
}
.buttons-container {
  margin-top: 29px;
}
.custom-file-input-label,
.custom-input-label {
  display: block;
  color: #727272;
  margin-bottom: 8px;
  font-size: 15px;
}

.ab-btn {
  min-width: 124px;
}

@media only screen and (max-width: 375px) {
  .custom-file-input-label {
    display: none;
  }

  .custom-input-label,
  .font-weight-normal {
    font-size: 12px;
  }

  .ab-btn {
    min-width: 140px;
  }
}
</style>
